// Module
var code = "<td name=shipmentUnitWrapper>{{ record.key | entityFormat }}</td> <td name=quantity>{{ getRemainingQuantity(record) }}</td> <td name=shipmentUnitWrapperCategory>{{ record.value[0].deliveryUnitData.shipmentUnitWrapperCategory | entityFormat }}</td> ";
// Exports
module.exports = code;